import {
    type OrganizationDataSourceAccount,
    type OrganizationFeatures,
} from '@libraries/typescript/api_client';

export const AUTHORIZATIONS_ENABLED_FEATURE_KEY = 'authorizations_enabled';

export function isAuthorizationsEnabled(
    features: OrganizationFeatures | null | undefined,
): boolean {
    return features?.[AUTHORIZATIONS_ENABLED_FEATURE_KEY] === true;
}

export function hasAuthorizationSyncProvider(
    dataSourceAccounts:
        | ReadonlyArray<OrganizationDataSourceAccount>
        | null
        | undefined,
): boolean {
    return (
        dataSourceAccounts?.some(
            (account) => account.supports_authorization_sync,
        ) ?? false
    );
}

export function canUseAuthorizations(
    features: OrganizationFeatures | null | undefined,
    dataSourceAccounts:
        | ReadonlyArray<OrganizationDataSourceAccount>
        | null
        | undefined,
): boolean {
    return (
        isAuthorizationsEnabled(features) &&
        hasAuthorizationSyncProvider(dataSourceAccounts)
    );
}
